/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RemovePatientDialog.vue?vue&type=template&id=0d0cc610"
import script from "./RemovePatientDialog.vue?vue&type=script&lang=js"
export * from "./RemovePatientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0cc610')) {
      api.createRecord('0d0cc610', component.options)
    } else {
      api.reload('0d0cc610', component.options)
    }
    module.hot.accept("./RemovePatientDialog.vue?vue&type=template&id=0d0cc610", function () {
      api.rerender('0d0cc610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/RemovePatientDialog.vue"
export default component.exports